import styled from 'styled-components';

export const FlapContainer = styled.button(({ theme: { size, color, transition } }) => ({
  left: '50%',
  transform: 'translateX(-50%)',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: size.units(6),
  height: size.units(3),
  borderRadius: `${size.units(1.5)} ${size.units(1.5)} 0 0`,
  backgroundColor: 'rgba(0, 0, 0, 0.5)',
  color: color.content.reversed.default(),
  border: 'none',
  cursor: 'pointer',
  zIndex: 20,
  WebkitTapHighlightColor: 'transparent',
  transition: transition.standard('background-color'),

  '&:hover': {
    backgroundColor: 'rgba(0, 0, 0, 0.65)',
  },

  '&:active': {
    backgroundColor: 'rgba(0, 0, 0, 0.7)',
  },
}));
